<template>
    <Modal
        :value="modalData.show"
        title="选择菜品"
        @on-cancel="cancel"
        @on-visible-change="onVisibleChange"
        :mask-closable="false"
        width="700"
        transfer
    >
        <div class="select-dish-container">
            <!-- 分类标签 -->
            <div class="category-tabs">
                <Tag
                    v-for="(category, index) in categories"
                    :key="index"
                    :color="
                        activeCategory === category.id ? 'orange' : 'default'
                    "
                    @click.native="changeCategory(category.id)"
                    style="
                        cursor: pointer;
                        margin-right: 8px;
                        margin-bottom: 8px;
                    "
                >
                    {{ category.cate_name }}
                </Tag>
            </div>

            <!-- 菜品列表 -->
            <div class="dish-list">
                <CheckboxGroup v-model="selectedDishes">
                    <div
                        v-for="dish in filteredDishes"
                        :key="dish.id"
                        class="dish-item"
                    >
                        <Checkbox :label="dish.id">
                            <span>{{ dish.goods_name }}</span>
                        </Checkbox>
                    </div>
                </CheckboxGroup>
            </div>
        </div>

        <div slot="footer">
            <Button @click="cancel">取消</Button>
            <Button
                style="background: #ff761d; border-color: #ff761d"
                @click="confirm"
                type="primary"
                >确定添加</Button
            >
        </div>
    </Modal>
</template>

<script>
import { comboGetGoods } from "@/api/customer";
export default {
    name: "selectDish",
    props: {
        modalData: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            activeCategory: "all",
            selectedDishes: [],
            categories: [
                { id: "all", cate_name: "全部" }
            ],
            allDishes: [],
        };
    },
    computed: {
        filteredDishes() {
            if (this.activeCategory === "all") {
                return this.allDishes;
            }
            return this.allDishes.filter(
                (dish) => dish.cate_id == this.activeCategory
            );
        },
    },
    watch: {
        "modalData.show": {
            handler(val) {
                if (val) {
                    this.selectedDishes = [];
                    this.getGoods();
                }
            },
        },
    },
    methods: {
        getGoods() {
            comboGetGoods().then((res) => {
                const backendCategories = res.data || [];
                
                // 添加"全部"分类到开头
                this.categories = [
                    { id: "all", cate_name: "全部" },
                    ...backendCategories
                ];
                
                // 将所有菜品合并到一个数组中
                this.allDishes = [];
                backendCategories.forEach((category) => {
                    if (category.goods && category.goods.length > 0) {
                        category.goods.forEach((dish) => {
                            this.allDishes.push({
                                id: dish.id,
                                goods_name: dish.goods_name,
                                cate_id: category.id,
                                cate_name: category.cate_name,
                                price: dish.price,
                                goods_img: dish.goods_img || '',
                            });
                        });
                    }
                });
            }).catch(err => {
                this.$Message.error(err.msg || '加载菜品失败');
            });
        },
        changeCategory(categoryId) {
            this.activeCategory = categoryId;
        },
        cancel() {
            this.closeModal();
        },
        onVisibleChange(visible) {
            if (!visible) {
                this.closeModal();
            }
        },
        closeModal() {
            this.$emit("input", false);
            const updatedModal = { ...this.modalData, show: false };
            this.$emit("update:modalData", updatedModal);
        },
        confirm() {
            const selectedDishList = this.allDishes.filter((dish) =>
                this.selectedDishes.includes(dish.id)
            );
            this.$emit("confirm", selectedDishList);
            this.closeModal();
        },
    },
};
</script>

<style scoped>
.select-dish-container {
    max-height: 450px;
    overflow-y: auto;
    padding-right: 10px;
}
.category-tabs {
    margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom: 1px solid #e8e8e8;
}
.dish-list {
    max-height: 300px;
    overflow-y: auto;
}
.dish-item {
    padding: 10px;
    border-bottom: 1px solid #f0f0f0;
}
.dish-item:last-child {
    border-bottom: none;
}
.empty-tip {
    text-align: center;
    color: #999;
    padding: 40px 0;
    font-size: 14px;
}
</style>

<style>
.ivu-btn-primary {
    background: #ff761d;
    border-color: #ff761d;
}
.ivu-btn-primary:hover {
    background: #ff761d;
    border-color: #ff761d;
}
.ivu-tag-orange {
    color: #ff761d;
    background: #fff7e6;
    border-color: #ffd591;
}
</style>
